import { render, staticRenderFns } from "./Challenge.vue?vue&type=template&id=4555d837&scoped=true&"
import script from "./Challenge.vue?vue&type=script&lang=js&"
export * from "./Challenge.vue?vue&type=script&lang=js&"
import style0 from "./Challenge.vue?vue&type=style&index=0&id=4555d837&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4555d837",
  null
  
)

export default component.exports